<template>
  <div class="scan-goods">
    <div class="shoppingCart">
	  <div class="list" v-if="pointList.length > 0" v-for="(orderItem,key) in pointList" :key="key">
		<div class="item acea-row row-between-wrapper" v-for="(item,index) in orderItem.info" :key="index">
		  <div class="picTxt acea-row row-between-wrapper">
			<div class="pictrue">
			  <img :src="item.productInfo.image" />
			</div>
			<div class="text">
			  <div class="line1">{{ item.productInfo.store_name }}</div>
			  <div class="infor line1">
				<p>属性：{{ item.productInfo.attrInfo.suk }}</p>
			  </div>
			  <div class="money">
				  <span class="font-color-red">￥{{ item.productInfo.attrInfo.price }}</span>
				  <span style="color: #777;margin-right: -0.5rem;">x{{ item.cart_num }}</span>
			  </div>
			</div>
		  </div>
		</div>
		<div class="point-btn-wapper">
			<div class="btn-del" @click="pointDel(key)">删除</div>
			<div class="btn-point" @click="$router.push('/user/scan_goods?uid=' + orderItem.uid + '&cartpoint=cartpoint')">取单</div>
		</div>
	  </div>
	  <div v-if="pointList.length == 0" class="noCart">
		<div class="pictrue"><img src="@assets/images/noCart.png" /></div>
		<button @click="$router.replace('/user/scan_goods?cartpoint=cartpoint')">返回扫码</button>
	  </div>
	</div>
  </div>
</template>

<script>
import { cartPoint, cartDeity } from "@api/order";
const NAME = "CartPoint";

export default {
  name: NAME,
  
  props: {},
  data: function() {
    return {
	  pointList: []
    };
  },
  watch: {
    $route(n) {
      if (n.name === "CartPoint") {
        this.postCartPoint();
      }
    }
  },
  mounted() {
	this.postCartPoint();
  },
  methods: {
	postCartPoint(){
		let that = this;
		cartPoint().then(res => {
			that.pointList = res.data;
		}).catch(err => {
			that.$dialog.error(err.msg);
		});
	},
	// 删除
	pointDel(key){
		let that = this,
		  data = {
			uid: that.pointList[key].uid,
			status: 3
		  };
		that.$dialog.confirm({
		  mes: "确认删除吗？",
		  opts: [
			{
			  txt: "取消",
			  color: false
			},
		    {
		      txt: "删除",
		      color: true,
		      callback: () => {
		        cartDeity(data).then(res => {
		        	that.pointList.splice(key, 1);
		        	that.$dialog.success('删除成功');
		        }).catch(err => {
		        	that.$dialog.error(err.msg);
		        });
		      }
		    }
		  ]
		});
	}
  }
};
</script>
<style scoped>
.shoppingCart{
	margin-bottom: 1.2rem;
}
.shoppingCart .list{
	margin-top: 0;
}
.shoppingCart .list .item{
	margin-bottom: 0;
	border-bottom: 1px solid #eee;
}
.point-btn-wapper{
	display: flex;
	justify-content: flex-end;
	align-items: center;
	padding: 0.2rem 0;
	background-color: #fff;
	margin-bottom: 0.2rem;
}
.point-btn-wapper>div{
	color: #fff;
	background-color: #e93323;
	border-radius: 0.5rem;
	margin-right: 0.2rem;
	padding: 0.1rem 0.3rem;
}
.noCart{
	background: none;
	text-align: center;
	color: #666;
}
.noCart button{
	width: 80%;
	height: 0.8rem;
	line-height: 0.8rem;
	text-align: center;
	background-color: #e93323;
	color: #fff;
	border-radius: 0.4rem;
	margin-top: 1rem;
	font-size: 0.32rem;
}
.shoppingCart .list .item .picTxt .text .money{display: flex;justify-content: space-between;}
</style>